"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _styles = require("../shared/styles");
var _Icon = require("./Icon");
var _jsxRuntime = require("react/jsx-runtime");
var Item = _styledComponents.default.div.withConfig({
  displayName: "ContextMenuArrowItem__Item",
  componentId: "sc-l3iodt-0"
})(["box-sizing:border-box;display:flex;flex-direction:row;align-items:center;justify-content:space-between;", " width:100%;padding:", " ", " ", " ", ";cursor:pointer;:hover{background-color:", ";}"], _styles.font.base.regular, _styles.spacing.xs, _styles.spacing.m, _styles.spacing.xs, _styles.spacing.m, _styles.colors.background.secondary.default);
var ContextMenuArrowItem = function ContextMenuArrowItem(_ref) {
  var children = _ref.children,
    onClick = _ref.onClick;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(Item, {
    onClick: onClick,
    children: [children, /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
      icon: 'chevronRight'
    })]
  });
};
ContextMenuArrowItem.defaultProps = {};
var _default = exports.default = ContextMenuArrowItem;